<script>
import NavBar from '@components/nav-bar'
import SideBar from '@components/side-bar'
import RightBar from '@components/right-bar'
import Footer from '@components/footer'
import store from '@state/store'

export default {
  components: { NavBar, SideBar, RightBar, Footer },
  data() {
    return {
      isSidebarEnable: true,
      isMenuScroll: true,
      user: this.$store ? this.$store.state.auth.currentUser : {} || {},
    }
  },
  computed: {
    sidebar: function () {
      return document.body.classList.contains('sidebar-enable') || true
    },
    enlarged: function () {
      return document.body.classList.contains('enlarged') || false
    },
  },
  created: function () {
    // set locale unit
    this.$i18n.locale = store.getters['auth/unitStandard']
    document.body.classList.remove('authentication-bg')
    document.body.classList.remove('authentication-bg-pattern') 
    this.isSidebarEnable = this.sidebar
    if (this.isSidebarEnable && this.isMobile()) {
      this.isMenuScroll = true
    }
  },
  methods: {
    isMobile() {
      const ua = navigator.userAgent
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
        ua
      )
    },
    toggleMenu() {
      this.isSidebarEnable = !this.isSidebarEnable
    },
    toggleRightSidebar() {
      document.body.classList.toggle('right-bar-enabled')
    },
    hideRightSidebar() {
      document.body.classList.remove('right-bar-enabled')
    },
  },
}
</script>

<template>
  <div id="wrapper">
    <NavBar :user="user" />
    <SideBar :is-sidebar-enable="isSidebarEnable" :is-scroll="isMenuScroll" />
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="content-page">
      <div class="content">
        <!-- Start Content-->
        <div class="container-fluid">
          <slot />
        </div>
      </div>
      <Footer />
    </div>
    <RightBar />
  </div>
</template>
